export const TermsPage = () => {
    return (
      <div className="container" style={{ minHeight: "80vh", padding: "20px" }}>
        <h1>Terms of Service</h1>
        <p>
          By using this website, you agree to our terms. All school information is provided as-is and is subject to change.
          We are not affiliated with any specific school and do not guarantee the accuracy of third-party content.
        </p>
      </div>
    );
  }
  